import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7b69a95a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "cms-module-title"
};
const _hoisted_3 = {
  class: "cms-module-title"
};
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { getInfoBySnApi, getAccountInfoApi, getSnRecordApi } from '@/api/traceDebug';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const loginOPtion = [{
      value: 0,
      label: 'SN'
    }, {
      value: 2,
      label: t('账号')
    }, {
      value: 1,
      label: t('激活码')
    }];
    const loading = ref(false);
    const accountType = ref(0);
    const size = ref({
      sm: 24,
      md: 12,
      lg: 8,
      xl: 6,
      xs: {}
    });
    const snData = ref();
    const accountData = ref();
    const activeCodeData = ref(); //sn|激活码|账号对应的input值

    const sn = ref();
    const activeCode = ref('');
    const account = ref('');
    const associateObj = ref({
      data: {},
      visible: false
    });
    const deviceObj = ref({
      data: {},
      visible: false
    });
    const searchConfig = ref({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '账号类型',
        prop: 'accountType',
        widgetType: 'Select',
        list: loginOPtion,
        change: val => {
          searchConfig.value.formList[1].label = loginOPtion.filter(item => item.value === val)[0].label; // 查询账号才显示关联信息

          if (val == 2) {
            associateObj.value.visible = true;
            deviceObj.value.visible = true;
          } else {
            associateObj.value.visible = false;
            deviceObj.value.visible = false;
          }
        }
      }, {
        label: 'SN',
        prop: 'account',
        widgetType: 'input'
      }],
      formData: {
        accountType: 0,
        account: ''
      }
    });
    const formData = ref();
    const actionForm = reactive({
      visible: false,
      // 预览图片路径
      imgUrl: '',
      formList: [[{
        label: 'SN',
        prop: 'sn',
        widgetType: 'text',
        disabled: true
      }, {
        label: '状态',
        prop: 'state',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '激活时间',
        prop: 'startTime',
        widgetType: 'text',
        disabled: true
      }, {
        label: '到期时间',
        prop: 'endTime',
        widgetType: 'text',
        disabled: true
      }], [{
        label: 'CID',
        prop: 'cid',
        widgetType: 'text',
        list: [],
        disabled: true
      }, {
        label: '品牌',
        prop: 'brandName',
        widgetType: 'text',
        list: [],
        disabled: true
      }], [{
        label: 'PID',
        prop: 'pid',
        widgetType: 'text',
        list: [],
        disabled: true
      }, {
        label: '平台',
        prop: 'platformName',
        widgetType: 'text',
        list: [],
        valueKey: 'label',
        multiple: true,
        disabled: true
      }], [{
        label: 'MID',
        prop: 'mid',
        widgetType: 'text',
        disabled: true
      }, {
        label: '型号',
        prop: 'modelName',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '更新时间',
        prop: 'updateTime',
        widgetType: 'text',
        disabled: true
      }]],
      associateFormList: [[{
        label: 'SN',
        prop: 'sn',
        widgetType: 'text',
        disabled: true
      }, {
        label: '状态',
        prop: 'state',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '激活时间',
        prop: 'startTime',
        widgetType: 'text',
        disabled: true
      }, {
        label: '到期时间',
        prop: 'endTime',
        widgetType: 'text',
        disabled: true
      }], [{
        label: 'CID',
        prop: 'cid',
        widgetType: 'text',
        list: [],
        disabled: true
      }, {
        label: '客户',
        prop: 'brandName',
        widgetType: 'text',
        list: [],
        disabled: true
      }], [{
        label: 'PID',
        prop: 'pid',
        widgetType: 'text',
        list: [],
        disabled: true
      }, {
        label: '平台',
        prop: 'platformName',
        widgetType: 'text',
        list: [],
        valueKey: 'label',
        multiple: true,
        disabled: true
      }], [{
        label: 'MID',
        prop: 'mid',
        widgetType: 'text',
        disabled: true
      }, {
        label: '型号',
        prop: 'modelName',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '更新时间',
        prop: 'updateTime',
        widgetType: 'text',
        disabled: true
      }]],
      deviceFormList: [[{
        label: '以太网mac地址',
        prop: 'ethMac',
        widgetType: 'text',
        disabled: true
      }, {
        label: 'Wifi mac地址',
        prop: 'wifiMac',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '蓝牙mac地址',
        prop: 'btMac',
        widgetType: 'text',
        disabled: true
      }, {
        label: 'android Id',
        prop: 'androidId',
        widgetType: 'text',
        disabled: true
      }], [{
        label: 'android系统版本',
        prop: 'androidVersion',
        widgetType: 'text',
        disabled: true
      }, {
        label: '品牌',
        prop: 'brand',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '型号',
        prop: 'model',
        widgetType: 'text',
        disabled: true
      }, {
        label: '制造商',
        prop: 'manufacturer',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '设备代号',
        prop: 'device',
        widgetType: 'text',
        disabled: true
      }, {
        label: '硬件名称',
        prop: 'hardware',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '主板型号',
        prop: 'board',
        widgetType: 'text',
        disabled: true
      }, {
        label: '内存大小(MB)',
        prop: 'memorySize',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '硬盘大小(MB)',
        prop: 'storageSize',
        widgetType: 'text',
        disabled: true
      }, {
        label: 'IMEI号',
        prop: 'imei',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '序列化号',
        prop: 'serialNumber',
        widgetType: 'text',
        disabled: true
      }]],
      formData,
      dialogConfig: {
        title: '新增'
      }
    });
    onMounted(() => {}); // 监听下拉框改变选中状态

    watch(() => searchConfig.value.formData.accountType, (newVal, oldVal) => {
      switch (newVal) {
        case 0:
          actionForm.formList = [[{
            label: 'SN',
            prop: 'sn',
            widgetType: 'text',
            disabled: true
          }, {
            label: '状态',
            prop: 'state',
            widgetType: 'text',
            disabled: true
          }], [{
            label: '激活时间',
            prop: 'startTime',
            widgetType: 'text',
            disabled: true
          }, {
            label: '到期时间',
            prop: 'endTime',
            widgetType: 'text',
            disabled: true
          }], [{
            label: 'CID',
            prop: 'cid',
            widgetType: 'text',
            list: [],
            disabled: true
          }, {
            label: '客户',
            prop: 'brandName',
            widgetType: 'text',
            list: [],
            disabled: true
          }], [{
            label: 'PID',
            prop: 'pid',
            widgetType: 'text',
            list: [],
            disabled: true
          }, {
            label: '平台',
            prop: 'platformName',
            widgetType: 'text',
            list: [],
            valueKey: 'label',
            multiple: true,
            disabled: true
          }], [{
            label: 'MID',
            prop: 'mid',
            widgetType: 'text',
            disabled: true
          }, {
            label: '型号',
            prop: 'modelName',
            widgetType: 'text',
            disabled: true
          }], [{
            label: '更新时间',
            prop: 'updateTime',
            widgetType: 'text',
            disabled: true
          }]];
          formData.value = snData.value;
          break;

        case 1:
          actionForm.formList = [[{
            label: '激活码',
            prop: 'userId',
            widgetType: 'text',
            disabled: true
          }, {
            label: '设备ID',
            prop: 'deviceId',
            widgetType: 'text',
            disabled: true
          }], [{
            label: '激活时间',
            prop: 'activationTime',
            widgetType: 'text',
            disabled: true
          }, {
            label: '到期时间',
            prop: 'effectiveTime',
            widgetType: 'text',
            disabled: true
          }]];
          formData.value = activeCodeData.value;
          break;

        case 2:
          actionForm.formList = [[{
            label: '用户名',
            prop: 'username',
            widgetType: 'text',
            disabled: true
          }, {
            label: 'ID',
            prop: 'id',
            widgetType: 'text',
            disabled: true
          }], [{
            label: '状态',
            prop: 'state',
            widgetType: 'text',
            disabled: true
          }, {
            label: '注册时间',
            prop: 'registerTime',
            widgetType: 'text',
            disabled: true
          }], [{
            label: '到期时间',
            prop: 'vipTime',
            widgetType: 'text',
            disabled: true
          }, {
            label: '手机',
            prop: 'phone',
            widgetType: 'text',
            disabled: true
          }], [{
            label: '邮箱',
            prop: 'email',
            widgetType: 'text',
            disabled: true
          }, {
            label: 'UNID',
            prop: 'iotUserId',
            widgetType: 'text',
            disabled: true
          }]];
          formData.value = accountData.value;
          break;
      }
    }, {
      deep: true
    }); //查询

    const handleSearch = async val => {
      snData.value = {};
      activeCodeData.value = {};
      accountData.value = {};
      if (val.account === '') return false;

      if (val.accountType === 0) {
        //sn查询 先查询对应的SN信息，再查询客户平台型号信息
        await getSnList(val.account);
        await get3IdData(val.account);
        formData.value = snData.value;
      } else if (val.accountType === 1) {
        //激活码查询
        await getAccountInfo(2, val.account);
        formData.value = activeCodeData.value;
      } else {
        //账号查询
        await getAccountInfo(3, val.account);
        formData.value = accountData.value;
      }
    }; //重置


    const handleReset = async () => {
      searchConfig.value.formData = {
        account: '',
        accountType: 0
      };
      searchConfig.value.formList[1].label = 'SN';
      formData.value = {};
      activeCodeData.value = [];
      snData.value = [];
      accountData.value = [];
      associateObj.value = {
        visible: false,
        data: {}
      };
      deviceObj.value = {
        visible: false,
        data: {}
      };
      loading.value = false;
    }; //获取客户、平台、型号的信息


    const get3IdData = async sn => {
      if (snData.value.sn === undefined) return false; //sn没有数据，则上一步未查询到数据，不再获取客户信息

      let params = {
        sn
      };
      const {
        data,
        code,
        total
      } = await getInfoBySnApi(params);

      if (code == 0) {
        snData.value = { ...snData.value,
          brandName: data.brandName,
          platformName: data.platformName,
          modelName: data.modelName
        };
      }
    };

    const accountStateObj = {
      0: t('未激活'),
      1: t('有效'),
      // 2: t('用户半停'),
      3: t('禁用'),
      // 4: t('欠费半停'),
      5: t('过期') // 6: t('预拆'),
      // 7: t('拆机'),

    }; //根据sn|账号|激活码查询数据

    const getAccountInfo = async (operatType, keyWord) => {
      try {
        loading.value = true;
        const {
          code,
          data
        } = await getAccountInfoApi(operatType, keyWord);

        if (code == 0) {
          if (data === null) {
            loading.value = false;
            return ElMessage({
              type: 'warning',
              message: t('未查询到数据')
            });
          }

          switch (operatType) {
            case 2:
              activeCodeData.value = {
                userId: data.userId,
                deviceId: data.deviceId,
                activationTime: data.activationTime,
                effectiveTime: data.effectiveTime
              };
              break;

            case 3:
              accountData.value = { ...data,
                state: accountStateObj[data.state]
              };
              console.log('ACCOUNT DATA', accountData.value);
              deviceObj.value.data = { ...data
              };
              break;
          }

          if (data.relationuser) {
            //存在关联信息,请求接口
            await getSnDataAndName(data.relationuser);
          } else {
            associateObj.value.data = {};
          }
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    }; // 拿关联的sn数据


    const getSnDataAndName = async sn => {
      try {
        const {
          code,
          data
        } = await getSnRecordApi({
          sn
        });

        if (code == 0) {
          associateObj.value.data = {
            cid: data.cid,
            mid: data.mid,
            pid: data.pid,
            sn: data.sn,
            startTime: data.startTime,
            endTime: data.endTime,
            state: data.iptvStop == 0 ? t('激活') : t('停用'),
            updateTime: data.updateTime
          };
        } //获取客户、平台、型号的信息


        const res = await getInfoBySnApi({
          sn
        });

        if (res.code == 0) {
          associateObj.value.data.brandName = res.data.brandName;
          associateObj.value.data.platformName = res.data.platformName;
          associateObj.value.data.modelName = res.data.modelName;
        }
      } catch (error) {}
    }; // 查询sn


    const getSnList = async sn => {
      try {
        loading.value = true;
        const {
          code,
          data
        } = await getSnRecordApi({
          sn
        });

        if (code == 0) {
          snData.value = { ...snData.value,
            cid: data.cid,
            mid: data.mid,
            pid: data.pid,
            sn: data.sn,
            startTime: data.startTime,
            endTime: data.endTime,
            state: data.iptvStop == 0 ? t('激活') : t('停用'),
            updateTime: data.updateTime
          };
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_el_card = _resolveComponent("el-card");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.value.formList,
        "form-data": searchConfig.value.formData,
        size: searchConfig.value.size,
        onSearch: handleSearch,
        onReset: handleReset,
        gutter: 50
      }, null, 8, ["form-list", "form-data", "size"])]), _withDirectives((_openBlock(), _createBlock(_component_el_card, {
        class: "info"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('基础信息')), 1), _createVNode(_component_FormTable, {
          col: ['20%', '30%', '20%', '30%'],
          "form-list": actionForm.formList,
          "form-data": actionForm.formData
        }, null, 8, ["form-list", "form-data"])]),
        _: 1
      })), [[_directive_loading, loading.value]]), deviceObj.value.visible ? _withDirectives((_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('设备信息')), 1), _createVNode(_component_FormTable, {
          col: ['20%', '30%', '20%', '30%'],
          "form-list": actionForm.deviceFormList,
          "form-data": deviceObj.value.data
        }, null, 8, ["form-list", "form-data"])]),
        _: 1
      })), [[_directive_loading, loading.value]]) : _createCommentVNode("", true)], 64);
    };
  }

});